import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function VendorDashboard() {
  const [orders, setOrders] = useState([]);
  const [vendor, setVendor] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const v = JSON.parse(localStorage.getItem('ts_user'));
    if (!v || v.role !== 'vendor') { navigate('/vendor/login'); return; }
    setVendor(v);
    axios.get('/api/vendor/orders').then(res => {
      setOrders(Array.isArray(res.data) ? res.data : (res.data.data || []));
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const logout = () => {
    localStorage.removeItem('ts_token');
    localStorage.removeItem('ts_user');
    delete axios.defaults.headers.common['Authorization'];
    navigate('/vendor/login');
  };

  const notifications = orders.filter(o => o.status === 'draft' || o.status === 'confirmed').length;

  const getStatusBadge = (status) => {
    const badges = {
      draft: { text: 'Awaiting Deposit', color: 'var(--warning)' },
      confirmed: { text: 'Confirmed - Start Production', color: 'var(--info)' },
      production: { text: 'In Production', color: 'var(--purple)' },
      shipped: { text: 'Shipped', color: 'var(--success)' },
      delivered: { text: 'Delivered', color: 'var(--gray-500)' }
    };
    const badge = badges[status] || badges.draft;
    return <span className="status-badge" style={{ background: badge.color, color: '#fff' }}>{badge.text}</span>;
  };

  const formatCurrency = (amount) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount || 0);

  const markAsShipped = async (orderId) => {
    const vessel = prompt('Enter vessel name:');
    const date = prompt('Enter ship date (YYYY-MM-DD):');
    if (vessel && date) {
      await axios.patch(`/api/vendor/orders/${orderId}/status`, { status: 'shipped', vessel_name: vessel, ship_date: date });
      const res = await axios.get('/api/vendor/orders');
      setOrders(Array.isArray(res.data) ? res.data : (res.data.data || []));
    }
  };

  if (loading) return <div className="loading-screen">Loading...</div>;

  return (
    <div className="vendor-dashboard">
      <header className="header">
        <div className="header-content">
          <div className="header-left">
            <div className="header-logo">TradeSync</div>
            <nav className="header-nav">
              <Link to="/vendor/dashboard" className="active">My Orders</Link>
            </nav>
          </div>
          <div className="header-right">
            {notifications > 0 && (
              <div style={{ background: '#ef4444', color: '#fff', padding: '6px 14px', borderRadius: 20, fontWeight: 600, fontSize: 13 }}>
                🔔 {notifications} pending
              </div>
            )}
            <div className="user-info">
              <span className="user-badge">vendor</span>
              <span>{vendor?.name}</span>
            </div>
            <button className="logout-btn" onClick={logout}>Logout</button>
          </div>
        </div>
      </header>

      <main className="dashboard-content">
        <div className="dashboard-header">
          <h2>Welcome, {vendor?.name}</h2>
          <p>Manage your orders and communicate directly with the buyer.</p>
        </div>

        {orders.length === 0 ? (
          <div className="empty-state"><div className="empty-state-icon">📋</div><h3>No active orders</h3></div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 20 }}>
            {orders.map(order => (
              <div key={order.id} style={{ background: 'var(--white)', borderRadius: 12, padding: 24, boxShadow: 'var(--shadow)', borderTop: `4px solid var(--primary)` }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                  <h3 style={{ margin: 0 }}>{order.order_number}</h3>
                  {getStatusBadge(order.status)}
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid var(--gray-100)' }}>
                  <span style={{ color: 'var(--gray-500)' }}>Amount:</span>
                  <strong>{formatCurrency(order.total_amount)} USD</strong>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid var(--gray-100)' }}>
                  <span style={{ color: 'var(--gray-500)' }}>Payment:</span>
                  <span>{order.deposit_paid ? '✅ Deposit Received' : '⏳ Awaiting Deposit'}</span>
                </div>
                {order.ship_date && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0' }}>
                    <span style={{ color: 'var(--gray-500)' }}>Ship Date:</span>
                    <span>{new Date(order.ship_date).toLocaleDateString()}</span>
                  </div>
                )}
                <div style={{ marginTop: 20, display: 'flex', flexDirection: 'column', gap: 8 }}>
                  <Link to={`/vendor/order/${order.id}`} className="submit-btn" style={{ textAlign: 'center', textDecoration: 'none' }}>
                    View Details & Chat
                  </Link>
                  {order.status === 'confirmed' && (
                    <button onClick={() => markAsShipped(order.id)} style={{ background: 'var(--success)', color: '#fff', border: 'none', padding: '12px', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}>
                      🚢 Mark as Shipped
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
